/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API
 * API for managing Y-sports related stuff
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlayerCreateRequest
 */
export interface PlayerCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof PlayerCreateRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerCreateRequest
     */
    secondName?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerCreateRequest
     */
    lastName: string;
    /**
     * Birth year
     * @type {number}
     * @memberof PlayerCreateRequest
     */
    birthDate: number;
    /**
     * 
     * @type {string}
     * @memberof PlayerCreateRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof PlayerCreateRequest
     */
    phoneNumber?: string;
    /**
     * Jersey/player number
     * @type {number}
     * @memberof PlayerCreateRequest
     */
    playerNumber?: number;
}

/**
 * Check if a given object implements the PlayerCreateRequest interface.
 */
export function instanceOfPlayerCreateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;
    isInstance = isInstance && "birthDate" in value;

    return isInstance;
}

export function PlayerCreateRequestFromJSON(json: any): PlayerCreateRequest {
    return PlayerCreateRequestFromJSONTyped(json, false);
}

export function PlayerCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayerCreateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'secondName': !exists(json, 'secondName') ? undefined : json['secondName'],
        'lastName': json['lastName'],
        'birthDate': json['birthDate'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'playerNumber': !exists(json, 'playerNumber') ? undefined : json['playerNumber'],
    };
}

export function PlayerCreateRequestToJSON(value?: PlayerCreateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'firstName': value.firstName,
        'secondName': value.secondName,
        'lastName': value.lastName,
        'birthDate': value.birthDate,
        'email': value.email,
        'phoneNumber': value.phoneNumber,
        'playerNumber': value.playerNumber,
    };
}

